import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props){
    super(props);
    this.state = {error: null};
  }
  static getDerivedStateFromError(error){
    return {error};
  }
  componentDidCatch(error, info){
    // in private app, we don't send errors externally — but we could log to internal store
    console.error('ErrorBoundary caught', error, info);
  }
  render(){
    if(this.state.error){
      return (
        <div style={{padding:24,textAlign:'center'}}>
          <h2 style={{color:'#c9a62b'}}>Something went wrong</h2>
          <pre style={{color:'#bdbdbd',whiteSpace:'pre-wrap'}}>{String(this.state.error)}</pre>
        </div>
      )
    }
    return this.props.children;
  }
}
